import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthStateService } from '@core/services/auth/auth-state';

export const rootRedirectGuard: CanMatchFn = () => {
  const router = inject(Router);
  const auth = inject(AuthStateService);

  return auth.isAuthenticated()
    ? router.createUrlTree(['/home'])
    : router.createUrlTree(['/login']);
};
